import './js/app.js';

import 'perfect-scrollbar/css/perfect-scrollbar.css';
import './scss/base.scss';
import './img/icons.svg';
